module.exports = __webpack_public_path__ + "static/media/engage-flowchart1.bddac4af.jpg";